import React, { useMemo } from 'react';
import {
  FormGroup,
} from 'reactstrap';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const onlyUnique = (value, index, self) => self.indexOf(value) === index;

const SearchTemplateByCategory = ({
  categories = [],
  category = {},
  setCategory,
  style,
}) => {
  const categoriesToUse = useMemo(() => categories.filter(onlyUnique), [categories]);

  return (
    <FormGroup style={style}>
      <Autocomplete
        value={category}
        onChange={(_, value) => {
          const { _id, titleEn } = value || {};

          if (!_id) {
            setCategory({});
          }
          setCategory({ _id, titleEn });
        }}
        options={categoriesToUse}
        getOptionLabel={({ _id: id, titleEn }) => titleEn || id || ''}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            variant="outlined"
            label="Search by category"
            placeholder="Search by category"
          />
        )}
      />
    </FormGroup>
  );
};

export default SearchTemplateByCategory;



// WEBPACK FOOTER //
// ./src/components/templates-manager/search-bar/search-templates-by-category.js